const VISIT_TRACKING_METHOD_COLUMN = 'trackMethod_id';

export const visitTrackingMethod = {
  name: VISIT_TRACKING_METHOD_COLUMN,
  label: 'Tracking Method',
  type: 'int',
  fieldType: 'integer'
};

export const visitTrackingMethodByName = {
  [VISIT_TRACKING_METHOD_COLUMN]: visitTrackingMethod
};
